export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('ka-GE', { style: 'currency', currency: 'GEL' }).format(value);
}
